export var Authority = {
    Authority: process.env.REACT_APP_AUTHORITY,
    ClientId: 'dcr',
    RedirectUri: 'signin-callback.html',
    ResponseType: 'code',
    Scope: 'openid profile dcr baseapi',
    PostLogoutRedirectUri: 'signout-callback.html',
    AutomaticSilentRenew: true,
    SilentRedirectUri: "signin-silent-callback.html",
    FirstPage: '/news',
    NativeDeepLink: 'postlogisticsdcr'
};
//# sourceMappingURL=Authority.js.map